
import React, { useState } from "react";
import { apiUrl } from "../../config";
import { FullDetails } from "../../design-system/components/FullDetails";

/**
 * FACEIT Data API: Teams
 * This page calls your backend wrapper for GET /teams/{team_id}.
 * What you get without fetching: team metadata (team_id, name, avatar) and a list of members with player_id, nickname, etc.
 */
export function TeamById() {
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);

  async function fetchTeam() {
    setErr(null);
    setData(null);
    if (!id) return;
    setLoading(true);
    try {
      const res = await fetch(apiUrl(`/api/faceit/teams/${encodeURIComponent(id)}`));
      const json = await res.json();
      if (!res.ok || json?.error) setErr(json?.error || `HTTP ${res.status}`);
      else setData(json);
    } catch (e: any) {
      setErr(e?.message || "Network error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-4">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold">FACEIT Team by ID</h2>
        <p className="text-sm text-muted">
          Returns a public <em>Team</em> document (team info and members roster).
        </p>
      </div>

      {/* Form */}
      <div className="bg-surface border border-border rounded-lg p-4 space-y-3">
        <div className="flex items-center gap-2">
          <input
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="FACEIT team_id"
            className="flex-1 bg-bg border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#4FC3F7]"
          />
          <button
            type="button"
            onClick={fetchTeam}
            disabled={!id || loading}
            className="px-3 py-2 rounded-md border border-border hover:border-[#4FC3F7] hover:text-[#4FC3F7] transition text-sm"
          >
            {loading ? "Loading…" : "Fetch"}
          </button>
        </div>

        {err && <pre className="text-xs text-red-400 overflow-x-auto">{err}</pre>}
      </div>

      {/* Result */}
      {data && (
        <FullDetails data={data} title="All fields" open />
      )}
    </div>
  );
}
``
